import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { Controller, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AreaNameError, Attribute, AttributeEditTxt, OptionEditTxt, ProAttributes, ProOption, Save, Title, Type } from "../../../Constant";
import { editAttribute, editAttributeRole, editOption, editOptionRole, viewAttribute, viewAttributeRole, viewVariant, viewVariantRole } from "../../../CommonUrl";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { useSelector } from "react-redux";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import Typeahead from "../../../CommonElements/TypeAhead";
import ColorPicker from "../../Common/ColorField/ColorPicker";

const OptionsEdit = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const param1 = params.get("id");

    const { register, handleSubmit, control, formState: { errors }, watch, setValue } = useForm({
        defaultValues: {}
    });
    const [loading, setLoading] = useState(false);
    const [AttributeOption, setAttributeOption] = useState([]);
    const [selectedAttrType, setSelectedAttrType] = useState('');
    const selectedColorCode = watch('colorValue');

    useEffect(() => {
        getAreaData();
    }, []);

    const getAreaData = async () => {
        setLoading(true);
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewVariant + `?option_id=${param1}` : viewVariantRole + `?option_id=${param1}`);
        if (data.status === true) {
            setValue('title', data.data[0].value);
            const payment = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewAttribute : viewAttributeRole);
            if (payment.status === true) {
                const optionsList = payment.data.map((items) => ({ value: items.id, label: items.title, type: items.type }));
                setAttributeOption(optionsList);
                const equalid = optionsList.find((setid) => setid.label === data.data[0].attribute_name);
                setValue("attribute", { value: equalid.value, label: equalid.label });
                setSelectedAttrType(equalid.type);
                if (equalid.type === 'color') {
                    setValue('colorValue', data.data[0].label); // Assuming the hex is in data.data[0].value
                }
            } else if (data.status >= 400 && data.status <= 405) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
            } else if (data.status >= 500 && data.status <= 505) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
            } else {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
            }
        } else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    }

    const onSubmit = async (data) => {
        setLoading(true)
        const postRequest = {
            option_id: param1,
            value: data.title, attribute_id: data.attribute.value, label: selectedColorCode
        };
        const editAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? editOption : editOptionRole, postRequest);
        if (editAreaResponse.data.status === true) {
            if (editAreaResponse.status === 200) {
                toast.success('Success...!')
                navigate(`${process.env.PUBLIC_URL}/Products/option`);
            } else {
                setLoading(false);
                toast.error(editAreaResponse.data.message)
            }
        } else if (editAreaResponse.status >= 400 && editAreaResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (editAreaResponse.status >= 500 && editAreaResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <Fragment>
            {loading && (
                <Transparentspinner />
            )}
            <Breadcrumbs mainTitle={ProOption} parent="Products" title={ProOption} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{OptionEditTxt}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="title">{Title}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="title" type="text" {...register('title', { required: true })} />
                                <span className="text-danger">{errors.title && AreaNameError}</span>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">{Attribute} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="attribute"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={AttributeOption}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                setSelectedAttrType(value?.type || '');
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.paymentmethod?.message}</p>
                            </Col>
                        </Row>
                        {selectedAttrType === 'color' && (
                            <Row className="g-3 pt-3">
                                <Col md="6">
                                    <Label className="form-label" htmlFor="colorValue">Select Color</Label>
                                    <ColorPicker
                                        selectedColorCode={selectedColorCode}
                                        setSelectedColorCode={(color) => {
                                            setValue('colorValue', color);
                                        }}
                                    />
                                </Col>
                            </Row>
                        )}
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default OptionsEdit;
